import React from 'react';
import { AccordionItem } from '../ui/Accordion';
export function CourseContentSection() {
  return <section className="py-16 md:py-24 bg-slate-950 px-4" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-47">
          ¿Qué vas a encontrar en el curso?
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-48">
          {/* Course Mockup */}
          <div data-id="element-49">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-700 bg-slate-900 p-4" data-id="element-50">
              <div className="aspect-[4/3] bg-slate-800 rounded-xl overflow-hidden relative" data-id="element-51">
                <img src="https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80" alt="Course Mockup" className="w-full h-full object-cover" data-id="element-52" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent flex items-end p-8" data-id="element-53">
                  <div data-id="element-54">
                    <span className="bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide mb-3 inline-block" data-id="element-55">
                      Programa Completo
                    </span>
                    <h3 className="text-2xl font-bold text-white" data-id="element-56">
                      Edición Profesional
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Accordion Modules */}
          <div className="space-y-1" data-id="element-57">
            <AccordionItem title="Módulo 0: Bienvenida y Mentalidad del Editor Profesional" isOpen={true} data-id="element-58">
              Arrancamos por lo más importante: la cabeza. Acá vas a entender
              qué hace diferente a un editor amateur de uno profesional, cómo
              pensar ofertas, clientes, valor y carrera. Vas a ordenar
              expectativas, evitar errores típicos y entrar con la mentalidad
              correcta para construir algo que escale de verdad.
            </AccordionItem>

            <AccordionItem title="Módulo 1: Edición en Capcut" data-id="element-59">
              Aprendés a editar desde cero con CapCut de forma práctica y
              profesional. Workflow real, cortes limpios, ritmo, subtítulos,
              estilos que funcionan en redes y cómo usar la herramienta como lo
              hacen los editores que trabajan para marcas y creadores. Sin
              vueltas técnicas innecesarias.
            </AccordionItem>

            <AccordionItem title="Módulo 2: Edición con IA (Imágenes y Videos)" data-id="element-60">
              Cómo usar inteligencia artificial para editar más rápido, mejor y
              con ventaja competitiva. Generación y mejora de imágenes, video,
              automatizaciones, prompts útiles y flujos reales de trabajo para
              producir más contenido en menos tiempo sin perder calidad.
            </AccordionItem>

            <AccordionItem title="Módulo 3: Monetización Real" data-id="element-61">
              Acá hablamos de plata, en serio. Cómo cobrar, qué servicios
              ofrecer, cómo armar paquetes, precios iniciales, ingresos extra y
              caminos reales para empezar a ganar dinero editando.
            </AccordionItem>

            <AccordionItem title="Módulo 4: Storytelling Profesional" data-id="element-62">
              Aprendés a contar historias que retienen, venden y convierten.
              Hooks, estructura, ritmo y emoción.
            </AccordionItem>

            <AccordionItem title="Módulo 5: Marca Personal Para Editores" data-id="element-63">
              Cómo posicionarte como editor profesional y atraer clientes.
            </AccordionItem>

            <AccordionItem title="Módulo 6: Pasos a Seguir Para Escalar" data-id="element-64">
              Procesos, organización, clientes más grandes y sistemas.
            </AccordionItem>

            <AccordionItem title="Módulo 7: Opciones de Escalado y Valor" data-id="element-65">
              Opciones de carrera: freelance, agencia, dirigir equipos o vender
              productos.
            </AccordionItem>

            <AccordionItem title="Módulo 8: Recursos y Páginas" data-id="element-66">
              Herramientas, páginas, recursos y referencias clave.
            </AccordionItem>
          </div>
        </div>
      </div>
    </section>;
}